import type { InferResponseType } from 'hono/client'

import { apiClient } from '@/apiClient'
import { Document } from '@/features/documents/types.ts'

// Type for the single document response from the API
type DocumentWithDetails = InferResponseType<
  (typeof apiClient.documents)[':documentId']['$get']
>['data']

/**
 * Converts DocumentWithDetails to Document type that components expect
 */
export function adaptDocumentWithDetailsToDocument(
  documentWithDetails: DocumentWithDetails | null
): Document | undefined {
  if (!documentWithDetails) return undefined

  // Extract only the fields that Document type expects
  return {
    id: documentWithDetails.id,
    name: documentWithDetails.name,
    summary: documentWithDetails.summary,
    status: documentWithDetails.status,
    processing_at: documentWithDetails.processing_at,
    in_review_at: documentWithDetails.in_review_at,
    created_at: documentWithDetails.created_at,
    updated_at: documentWithDetails.updated_at,
    deleted_at: documentWithDetails.deleted_at,
    attributes: documentWithDetails.attributes,
    // Map additional fields as needed
  } as Document
}
